import React from "react";
import { View, TouchableOpacity, StyleSheet } from "react-native";
import Text from "@components/CustomText";
import { tokens } from "../styles";

// Header bar matching project/components/Header.tsx — back arrow at left,
// title centered-ish, optional right-icon slot.
//
// Caller hands in `onBack` (usually navigation.goBack) and an optional
// `right` element (e.g. a search icon TouchableOpacity).

const Header = ({ title, subtitle, onBack, right }) => (
  <View style={styles.wrap}>
    {onBack ? (
      <TouchableOpacity
        onPress={onBack}
        activeOpacity={0.7}
        hitSlop={{ top: 12, bottom: 12, left: 12, right: 12 }}
        style={styles.iconBtn}
      >
        <Text variant="title_18" style={styles.backArrow}>
          ←
        </Text>
      </TouchableOpacity>
    ) : (
      <View style={styles.iconBtn} />
    )}
    <View style={styles.titleBlock}>
      <Text variant="title_18" style={styles.title} numberOfLines={1}>
        {title || ""}
      </Text>
      {subtitle ? (
        <Text variant="caption_2" style={styles.subtitle} numberOfLines={1}>
          {subtitle}
        </Text>
      ) : null}
    </View>
    <View style={right ? styles.rightSlot : styles.iconBtn}>
      {right || null}
    </View>
  </View>
);

export default Header;

const styles = StyleSheet.create({
  wrap: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: tokens.spacing.medium,
    paddingTop: tokens.spacing.small,
    paddingBottom: tokens.spacing.medium,
    backgroundColor: tokens.surface,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: tokens.borderLight,
  },
  iconBtn: {
    width: 40,
    height: 40,
    alignItems: "center",
    justifyContent: "center",
  },
  rightSlot: {
    minWidth: 40,
    height: 40,
    paddingHorizontal: tokens.spacing.tiny,
    alignItems: "flex-end",
    justifyContent: "center",
  },
  backArrow: { color: tokens.textPrimary, fontSize: 22 },
  titleBlock: { flex: 1, paddingHorizontal: tokens.spacing.small },
  title: {
    color: tokens.textPrimary,
    fontWeight: "700",
    fontSize: 17,
  },
  subtitle: {
    color: tokens.textSecondary,
    fontSize: 12,
    marginTop: 2,
  },
});
